import { SnapScroll } from './snap-scroll.component'
import { SnapScrollHandle } from './snap-scroll.types'
export { SnapScroll }
export type { SnapScrollHandle }
